import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-movie-2-fill text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-xl text-background-50">
                  黄瓜影院
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                黄瓜影院致力于为用户提供海量高清影视资源，免费在线观看最新电影、电视剧、动漫和综艺节目。高清画质，流畅播放，让追剧成为一种享受。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                <li><Link to="/category/movie" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">电影专区</Link></li>
                <li><Link to="/category/tv" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">电视剧专区</Link></li>
                <li><Link to="/category/anime" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">动漫专区</Link></li>
                <li><Link to="/category/variety" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">综艺专区</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">热门推荐</h4>
              <ul className="space-y-2.5">
                <li><Link to="/article/art-002" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">《繁花》现象级热剧解析</Link></li>
                <li><Link to="/article/art-001" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">2025年值得期待的国产电影</Link></li>
                <li><Link to="/article/art-004" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">国漫崛起之路</Link></li>
                <li><Link to="/article/art-006" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">近期高分电视剧推荐</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">关于我们</h4>
              <ul className="space-y-2.5">
                <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">品牌介绍</Link></li>
                <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">联系我们</Link></li>
                <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">用户口碑</Link></li>
              </ul>
              <div className="flex gap-3 mt-5">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-700 text-background-300 hover:text-background-50 hover:bg-primary-600 transition-all cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-700 text-background-300 hover:text-background-50 hover:bg-primary-600 transition-all cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-700 text-background-300 hover:text-background-50 hover:bg-primary-600 transition-all cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-background-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; 2025 黄瓜影院 huanggua.tv - 免费电视剧全集最新剧集完整版，高清影视在线观看
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">服务条款</a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}